<template>
  <span :class="[$options.name]">
    {{ timeToDisplay }}
  </span>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, PropType, ref } from "vue";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/pl";
import "dayjs/locale/pt";
dayjs.locale(window.$_t("lang"));
dayjs.extend(relativeTime);

export default defineComponent({
  name: "CommonDateDisplay",
  props: {
    date: {
      type: null as unknown as PropType<number | null>,
      required: true,
    },
    direction: {
      type: String as () => "from" | "to",
      default: "from",
    },
  },
  setup(props) {
    const timeToDisplay = ref<string>("");
    const timeInterval = ref<undefined | ReturnType<typeof setInterval>>(undefined);
    const timeDiff = props.date === null ? 0 : Math.abs(dayjs().diff(dayjs(props.date), "hour")); // get time difference in hours
    const timeout = (timeDiff < 1 ? 1 : 60) * 60 * 1000; // update displayed time every 1 minute or 1 hour

    onMounted(() => {
      if (props.date === null) {
        return;
      }
      timeToDisplay.value = props.direction === "from" ? dayjs(props.date).fromNow() : dayjs(props.date).toNow();
      if (timeDiff < 24) {
        // do not update displayed time if it is older than 24 hours
        timeInterval.value = setInterval(() => {
          timeToDisplay.value = props.direction === "from" ? dayjs(props.date).fromNow() : dayjs(props.date).toNow();
        }, timeout);
      }
    });

    onUnmounted(() => {
      clearInterval(timeInterval.value);
    });

    return {
      timeToDisplay,
    };
  },
});
</script>

<style lang="scss" scoped>
.CommonDateDisplay {
  //
}
</style>
